import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { CLIENTS_CUSTOMER, CLIENTS_CUSTOMER_SUCCESS, CLIENTS_CUSTOMER_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getClientCustomers({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/clientCustomers`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        pageSize: Constant?.TABLE_PAGE_SIZE,
        ...payload?.urlParam,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: CLIENTS_CUSTOMER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CLIENTS_CUSTOMER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CLIENTS_CUSTOMER_ERROR, payload: error });
  }
}

export function* watchClientCustomers() {
  yield takeEvery(CLIENTS_CUSTOMER, getClientCustomers);
}

function* clientCustomersSaga() {
  yield all([fork(watchClientCustomers)]);
}

export default clientCustomersSaga;
